import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const STATUSES = ["new", "replied", "closed"];

export default function Messages() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/contact_messages").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (it, status) => { try { await api.put(`/admin/contact_messages/${it.id}`, { ...it, status }); toast.success("Updated"); load(); } catch { toast.error("Failed"); } };
  const remove = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/contact_messages/${id}`); load(); };

  return (
    <div>
      <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-2">// Contact Messages</div>
      <h1 className="font-display font-black text-4xl text-white uppercase mb-8">Inbox</h1>
      <div className="space-y-4">
        {items.length === 0 && <div className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6 text-slate-500 text-sm">No messages yet.</div>}
        {items.map((it) => (
          <div key={it.id} className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6" data-testid={`msg-${it.id}`}>
            <div className="flex flex-col md:flex-row md:justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-head uppercase tracking-widest text-white">{it.name}</span>
                  <span className="text-xs font-mono-lt text-[var(--lt-accent-bright)]">{it.category}</span>
                </div>
                <div className="text-xs text-slate-500 mt-1">{it.email}{it.phone ? ` · ${it.phone}` : ""}</div>
                <div className="mt-3 text-sm text-slate-300">{it.message}</div>
              </div>
              <div className="flex items-center gap-2">
                <Select value={it.status} onValueChange={(v) => setStatus(it, v)}>
                  <SelectTrigger className="w-32 bg-[var(--lt-bg)] border-[var(--lt-border)] text-white h-9 rounded-xl text-xs uppercase"><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
                <Button size="sm" variant="ghost" onClick={() => remove(it.id)} className="text-slate-500 hover:text-red-400 rounded-xl">Delete</Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
